import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Content } from './style';

const ModalKonfirmasi = ({ show, onHide, onSubmit }) => (
  <Content>
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {' '}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Form Konfirmasi</h4>
        <p>
          Apakah Anda Ingin mengirim form ini sekarang?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btnCancel" variant="danger" onClick={onHide}>Kembali</Button>
        <Button variant="success" onClick={onSubmit} data-testid="konfirmasi">Konfirmasi</Button>
      </Modal.Footer>
    </Modal>
  </Content>
);

ModalKonfirmasi.defaultProps = {
  show: false,
  onHide: () => 'Do Nothing',
  onSubmit: () => 'Do Nothing',
};

ModalKonfirmasi.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ModalKonfirmasi;
